//@flow
import { getRootStore } from "./Store";
import { store } from "cockpit-shared";

export function getOnTokenExpiredHandler() {
  return () => {
    getRootStore().dispatch(store.authentication.authenticationActions.logout());
  };
}
